import { NgIf } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MessageCenter } from "src/app/core/_models/news-article.model";
import { CustomDatePipe } from "../../pipes/custom-date.pipe";

@Component({
  selector: "app-message-details-dialog",
  templateUrl: "./message-details-dialog.component.html",
  styleUrls: ["./message-details-dialog.component.scss"],
  imports: [MatDialogModule, NgIf, CustomDatePipe],
})
export class MessageDetailsDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MessageCenter,
    public dialog: MatDialog,
  ) {}
  closeDialog() {
    this.dialog.closeAll();
  }
}
